import { useKanzlei } from '../context';
import { useClientList } from './useRegistrations';

// Kennzahl „Mandanten“: Admin mit Zahl offener Zuweisungen, Mitarbeiter „Ihnen zugewiesen“.
// Wer nur Lohn macht (keinen Mandanten als FiBu), sieht die Kachel nicht.
export function MandantenKpi() {
  const { me } = useKanzlei();
  const admin = me.user.isAdmin;
  const list = useClientList();
  if (!list.data) return null;
  const clients = list.data.clients;
  if (!admin && !clients.some((c) => c.fibu?.id === me.user.id)) return null;
  const open = clients.filter((c) => !c.fibu || !c.lohn).length;
  return (
    <div className="card">
      <div className="kl">Mandanten</div>
      <div className="kv num">{clients.length}</div>
      <div className="ks">{admin ? `${open} mit offener Zuweisung` : 'Ihnen zugewiesen'}</div>
    </div>
  );
}
